import React, { Component } from "react";
import { connect } from "react-redux";
import { Field, reduxForm } from "redux-form";
import compose from "ramda/src/compose";
import { func } from "prop-types";
import { translate } from "react-i18next";
import mapObjIndexed from "ramda/src/mapObjIndexed";
import values from "ramda/src/values";

import {
  Form,
  Button,
  FloatLabelInput,
  FloatLabelTextArea,
  FloatLabelSelect,
} from "shared/components";
import styles from "../../styles.css";
import { createOdinIncident } from "../../../../services/state/actions";
import * as Mask from "../../../../services/utils/mask";

const OdinIncidentTimeSlotOptions = {
  MANHA: "MANHÃ",
  TARDE: "TARDE",
  "MANHA OU TARDE": "MANHÃ OU TARDE",
};

const required = (value) => (value ? undefined : "Campo obrigatório");
class OdinIncidentForm extends Component {
  onSubmit = (form) => {
    const { createOdinIncident, onNextStep, onReset, t } = this.props;

    const checklist = {
      data: { ...form },
      labels: {
        contactName: t("MSG_0212"),
        contactPhone: t("MSG_0206"),
        description: t("MSG_0202"),
        timeSlot: t("MSG_0205"),
      },
    };

    return createOdinIncident(checklist, onNextStep, onReset);
  };

  renderNameInput = (field) => {
    const {
      meta: { touched, error, invalid },
    } = field;
    return (
      <FloatLabelInput
        id="contactName"
        name="contactName"
        onChange={field.input.onChange}
        label={field.label}
        value={field.input.value ? field.input.value : ""}
        invalid={touched && invalid}
        error={error}
      />
    );
  };

  renderPhoneInput = (field) => {
    const {
      meta: { touched, error, invalid },
    } = field;
    return (
      <FloatLabelInput
        id="contactPhone"
        name="contactPhone"
        onChange={field.input.onChange}
        label={field.label}
        maxLength="15"
        value={field.input.value ? field.input.value : ""}
        invalid={touched && invalid}
        error={error}
      />
    );
  };

  renderDescriptionInput = (field) => {
    const {
      meta: { touched, error, invalid },
    } = field;
    return (
      <FloatLabelTextArea
        id="description"
        name="description"
        label={field.label}
        preset="modalTextArea"
        onChange={field.input.onChange}
        value={field.input.value ? field.input.value : ""}
        invalid={touched && invalid}
        error={error}
        noResize
      />
    );
  };

  renderTimeSlotInput = (field) => {
    const {
      meta: { touched, error, invalid },
    } = field;

    // FloatLabelSelect data mapping
    const options = values(
      mapObjIndexed((label, value) => ({ label, value }), field.options)
    );

    return (
      <FloatLabelSelect
        id="timeSlot"
        name="timeSlot"
        options={options}
        label={field.label}
        invalid={touched && invalid}
        error={error}
        defaultOption
        {...field.input}
      />
    );
  };

  render() {
    const { handleSubmit, onPreviousStep, t, product } = this.props;
    return (
      <Form onSubmit={handleSubmit(this.onSubmit)}>
        <h4 className={styles.title}>{product.productName}</h4>
        <p className={styles.formInstructions}>{t("MSG_0211")}</p>
        <Field
          name="contactName"
          validate={required}
          component={this.renderNameInput}
          label={t("MSG_0212")}
        />
        <Field
          validate={required}
          name="contactPhone"
          component={this.renderPhoneInput}
          label={t("MSG_0206")}
          format={Mask.phone}
          normalize={Mask.algarPhone}
        />
        <Field
          validate={required}
          name="description"
          component={this.renderDescriptionInput}
          label={t("MSG_0202")}
        />
        <Field
          label={t("MSG_0205")}
          name="timeSlot"
          options={OdinIncidentTimeSlotOptions}
          component={this.renderTimeSlotInput}
          validate={required}
        />
        <div className={styles.incidentModalButtons}>
          <Button onClick={onPreviousStep} relevance="low">
            {t("MSG_0292")}
          </Button>

          <Button relevance="normal" type="submit" callToAction>
            {t("MSG_0210")}
          </Button>
        </div>
      </Form>
    );
  }
}

OdinIncidentForm.propTypes = {
  onPreviousStep: func.isRequired,
  onNextStep: func.isRequired,
};

function validate(values) {
  const error = {};
  return error;
}

const reduxFormConfig = {
  form: "OdinIncidentForm",
  validate,
};

const mapStatetoProps = ({ repair }) => ({
  product: repair.wizard.product,
});

const enhance = compose(
  translate(),
  reduxForm(reduxFormConfig),
  connect(mapStatetoProps, { createOdinIncident })
);

export default enhance(OdinIncidentForm);



// WEBPACK FOOTER //
// ./src/components/RepairWizard/components/ModalOdinIncident/OdinIncidentForm.js